import { Link } from "react-router-dom";
import { ArrowRight, Code2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useSite } from "@/context/SiteContext";

// Small, discreet home panel (no price shown on the home page).
export const DevPanel = ({ slim = false, testId = "home-dev-panel" }) => {
  const { t } = useI18n();
  const { marketplace } = useSite();
  if (!marketplace) return null;
  if (slim) return (  // same compact box as the custom-plan CTA, stacked on phones
    <div className="flex w-full min-w-0 max-w-full flex-col items-stretch gap-3 rounded-2xl border border-[rgba(245,197,66,0.3)] bg-black/30 px-4 py-3 sm:flex-row sm:flex-wrap sm:items-center" data-testid={testId}>
      <p className="w-full min-w-0 text-start text-sm text-neutral-200 hyphens-none [overflow-wrap:break-word] [word-break:normal] sm:w-auto sm:flex-1 sm:basis-64">{t("devPanel.short")}</p>
      <Link to="/hebergement" className="btn-gold btn-sm min-h-[44px] w-full max-w-full justify-center hyphens-none whitespace-normal text-center sm:w-auto sm:shrink-0" data-testid={`${testId}-link`}>
        <Code2 className="h-4 w-4 shrink-0" /> {t("hosting.cta")}
      </Link>
    </div>
  );
  return (
    <section className="mx-auto max-w-7xl px-4 pt-16 sm:px-8" data-testid="home-dev-panel">
      <Link
        to="/hebergement"
        className="group flex items-center gap-3 rounded-2xl border border-[rgba(245,197,66,0.3)] bg-black/40 px-4 py-4 sm:gap-4 sm:px-5 transition-colors duration-200 hover:border-[var(--gold)] hover:bg-[rgba(74,6,11,0.35)]"
        data-testid="home-dev-panel-link"
      >
        <Code2 className="h-6 w-6 shrink-0 text-[var(--gold)]" />
        <span className="min-w-0 flex-1 text-sm text-neutral-200">{t("devPanel.text")}</span>
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[var(--gold)] text-[var(--gold-bright)] transition-transform duration-200 group-hover:translate-x-1 rtl:group-hover:-translate-x-1" data-testid="home-dev-panel-arrow">
          <ArrowRight className="h-4 w-4 rtl:-scale-x-100" />
        </span>
      </Link>
    </section>
  );
};
